export default __webpack_public_path__ + "other.d09818ef.svg";